module.exports = __webpack_public_path__ + "img/list_4.02885904.jpg";